import React from 'react';
import { Box, Link } from '@mui/material';

export const PagesNavigation = ({ pages }) => (
    <Box
        sx={{
            display: { xs: 'none', desktop: 'flex' },
            flexGrow: 1,
            justifyContent: 'center',
            gap: 4
        }}
    >
        {pages.map(page => (
            <Link
                key={page.label}
                href={page.href}
                target={page.isExternal ? '_blank' : undefined}
                rel={page.isExternal ? 'noopener noreferrer' : undefined}
                underline='none'
                sx={{
                    display: {
                        xs: page.hideOnMobile ? 'none' : 'flex',
                        desktop: 'flex'
                    },
                    color: 'white',
                    fontSize: '14px',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    '&:hover': {
                        backgroundColor: 'transparent',
                        color: 'white'
                    },
                    '&:focus': {
                        outline: 'none',
                        color: 'white'
                    },
                    '&:focus-visible': {
                        outline: '2px solid white',
                        color: 'white'
                    }
                }}
            >
                {page.label}
            </Link>
        ))}
    </Box>
);
